import ErrorFallbacks from "@src/components/ErrorFallbacks";
import React from "react";
import { quitWebviewDeeplink } from "@src/utils/goBack";

const PageNotFound = () => {
  return <ErrorFallbacks statusCode={404} />;
};

PageNotFound.getLayoutProps = () => ({
  handleBack: quitWebviewDeeplink,
  noPullToRefresh: true,
  noFooter:true,
});

export default PageNotFound;
